import { render, staticRenderFns } from "./AddDocuments.vue?vue&type=template&id=2e6f68b2"
import script from "./AddDocuments.vue?vue&type=script&lang=js"
export * from "./AddDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports